module.exports = __webpack_public_path__ + "img/3-supervalue-assist-home.7791b3a8.jpg";